import type { DeferredSpawn } from '../types';
import { registerWeapon, lookupWeapon, createProjectile } from './registry';
import { HUGE_CRATER, DEFAULT_CRATER } from '../terrain/crater-shapes';

export const NUKE = registerWeapon({
  id: 'nuke',
  name: 'Nuke',
  description: 'Devastating explosion + ring of secondary blasts. Changes the map.',
  tier: 'LEGENDARY',
  rarity: 'legendary',
  projectileRadius: 14,
  projectileSpeed: 0.40,
  color: 0xffff00,
  gravity: 0.18,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 60,
  blastRadius: 180,
  knockbackMult: 0.12,
  knockbackRadius: 1.5,
  shakeIntensity: 1.5,
  particleScale: 3.0,
  craterShape: HUGE_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.7,
  onImpact(proj, x, y, _hitType, _hitIndex, state, _fx) {
    const spawns: DeferredSpawn[] = [];
    const secondaryWeapon = lookupWeapon('nuke_secondary');
    for (let i = 0; i < 6; i++) {
      const angle = (i / 6) * Math.PI * 2;
      // Spawn outside the main crater (radius 180) so they land on intact terrain
      const dist = 230;
      const sx = x + Math.cos(angle) * dist;
      const sy = y + Math.sin(angle) * dist - 60; // above ring position
      // Outward velocity — arc away from crater
      const outVx = Math.cos(angle) * 4;
      const outVy = Math.sin(angle) * 3 - 2; // slight upward bias
      spawns.push({
        spawnFrame: state.frameCount + 18 + i * 3, // staggered cascade
        spawned: false,
        projectile: createProjectile(
          secondaryWeapon, sx, sy,
          outVx, outVy,
          proj.owner, state.frameCount, 1,
        ),
      });
    }
    return spawns;
  },
});

// Nuke secondary sub-weapon (not in lottery pool)
registerWeapon({
  id: 'nuke_secondary',
  name: 'Nuke Ring',
  description: '',
  tier: 'SUB',
  rarity: 'common',
  projectileRadius: 5,
  projectileSpeed: 0.55,
  color: 0xffaa00,
  gravity: 0.20,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 22,
  blastRadius: 70,
  knockbackMult: 0.06,
  knockbackRadius: 1.2,
  shakeIntensity: 3.0,
  particleScale: 1.0,
  craterShape: DEFAULT_CRATER,
});
